import React from 'react'

const TAB_LABELS = {
  measurements: { label: 'Measurements', icon: 'fa-ruler' },
  sizes: { label: 'Measurements', icon: 'fa-ruler' },
  grid: { label: 'Grid Style', icon: 'fa-border-inner' },
  obscurity: { label: 'Obscurity', icon: 'fa-objects-column' },
  blinds: { label: 'Internal Blinds', icon: 'fa-blinds' },
  job_photos: { label: 'Job Photos', icon: 'fa-image' },
  removal: { label: 'Removal', icon: 'fa-trash' },
  endLite: { label: 'End Lite', icon: 'fa-lightbulb' }
}

const TabNavigation = ({ tabs, activeTab, onTabChange }) => {
  // Map tab names to testid names for cucumber tests
  const getTestId = (tab) => {
    const testIdMap = {
      measurements: 'category-measurements',
      sizes: 'category-window_product_size',
      grid: 'category-grid_location',
      obscurity: 'category-obscurity_location',
      blinds: 'category-internal_blind',
      job_photos: 'category-job_photos'
    }
    return testIdMap[tab] || `category-${tab}`
  }

  return (
    <nav className="flex gap-4 w-full overflow-x-auto snap-x snap-mandatory" aria-label="Tabs">
      {tabs.map((tab) => {
        const isActive = activeTab === tab
        const { label, icon } = TAB_LABELS[tab] || { label: tab }

        return (
          <button
            type="button"
            key={tab}
            onClick={() => onTabChange(tab)}
            className={`
              flex items-center gap-2 whitespace-nowrap px-4 py-3 font-medium text-sm rounded snap-start
              ${isActive ? 'bg-brand text-white' : 'bg-light'}
            `}
            aria-current={isActive ? 'page' : undefined}
            data-testid={getTestId(tab)}
          >
            {icon && <i className={`fa-regular ${icon}`} aria-hidden="true"></i>}
            {label}
          </button>
        )
      })}
    </nav>
  )
}

export default TabNavigation
